import React, { useEffect, useRef } from "react";
import ScrollToTop from "../components/ScrollToTop";
import HelmetComponent from "../components/Helmet";

const CookiesPolicy = () => {
    const CookiesSection = useRef(null);

    useEffect(() => {
        if (CookiesSection.current) {
            CookiesSection.current.scrollIntoView({ behavior: "smooth" });
        }
    }, []);
    return (
        <>
            <div className="max-md:px-4 lg:px-5 xl:px-5 py-4 scroll-mt-[90px]" ref={CookiesSection}>
                <HelmetComponent
                    title="Cookies Policy | Shri Radhe Holidays"
                    description="Learn how Shri Radhe Holidays uses cookies and tracking technologies to improve website experience, analytics and personalized travel services."
                    url="https://www.shriradheholidays.com/cookiesPolicy"
                />

                <h1 className="  playfair-display font-extrabold py-[6px] px-2 max-sm:text-xl xl:text-2xl text-white  text-start border-l-8 rounded-r-full bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12"
                    style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                >
                    Cookies Policy
                </h1>
                <div className="max-md:px-3 lg:px-3 xl:px-3">
                    {/* <h2 className="mb-3 text-[#D4AF37] max-md:text-3xl text-4xl w-full xl font-extrabold playfair-display mt-4">
                        Our Cookies Policy
                    </h2> */}
                    <p className="mb-4 mt-4 text-justify poppins">
                        At <strong>Shri Radhe Holidays</strong>, we use cookies to improve your browsing experience, analyze site traffic, and personalize content. This policy explains how we use cookies and how you can manage them.
                    </p>

                    <h3 className="h4 mb-3" style={{ fontWeight: "bolder" }}>What Are Cookies?</h3>
                    <p className="mb-4 text-justify poppins">
                        Cookies are small text files stored on your device when you visit a website. They help us remember your preferences, improve performance, and provide relevant content.
                    </p>

                    <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Types of Cookies We Use</h3>
                    <ul className="poppins" style={{ marginBottom: "3rem", paddingLeft: "20px", listStyleType: "disc" }}>
                        <li className="poppins"><strong>Essential Cookies:</strong> Required for website functionality, such as secure logins and order processing.</li>
                        <li className="poppins"><strong>Analytical Cookies:</strong> Help us understand how visitors interact with our site, improving user experience.</li>
                        <li className="poppins"><strong>Marketing Cookies:</strong> Used for personalized ads and promotional campaigns.</li>
                        <li className="poppins"><strong>Functional Cookies:</strong> Remember user preferences for a tailored experience.</li>
                    </ul>

                    <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Managing Cookies</h3>
                    <p className="mb-4 text-justify poppins">
                        You can manage or delete cookies through your browser settings. However, disabling cookies may impact your experience on our website.
                    </p>

                    <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Changes to This Policy</h3>
                    <p className="mb-4 text-justify poppins">
                        We may update this policy from time to time. Please review it periodically to stay informed about how we use cookies.
                    </p>

                    {/* Footer Section */}
                    {/* <div className="text-center mt-8">
                        <p className="dancing-script-font text-4xl md:text-6xl text-[#86B817] ">
                            Shri Radhe Holidays
                        </p>
                        <p className="text-sm md:text-lg hanuman-regular">
                            Where Every Trip Feels Divine.
                        </p>
                    </div> */}
                </div>
            </div>
            <ScrollToTop />
        </>
    );
};

export default CookiesPolicy;
